export default {
  namespaced: true,
  commands: {
    title: "Comando personalizado",
    title_main: "Comando personalizado",
    action_add: 'Crear comando personalizado',
    action_update: 'Actualizar comando personalizado',
    base_commands: 'Comandos base',
    custom_commands: 'Comandos personalizados',
    fields: {
      name: {
        label: 'Nombre del comando',
        placeholder: 'Nombre del comando'
      },
      description: {
        label: 'Descripción del comando',
        placeholder: 'Descripción del comando'
      },
      alarm_compatible: {
        label: "¿Es compatible con alarmas?"
      },
      requirements: {
        label: 'Requerimientos (opcional)'
      }
    },
    messages: {
      success_created: 'Comando personalizado creada correctamente',
      success_updated: 'Comando personalizado actualizado correctamente',
      layout_empty: 'No se puede guardar un comando vacío',
      connections_empty: 'No están permitido nodos sin conexiones',
      connections_qty_exceeded: 'No están permitido nodos con múltiples conexiones',
      incomplete_node_config: 'Configuración incompleta en los siguientes nodos',
      alarm_category_requires_alarm_compatibility: 'Este comando solo es compatible con alarmas. Activa “¿Es compatible con alarmas?” para usarlo.',
    },
    btns: {
      delete_image: 'Eliminar imagen',
      create: 'Guardar',
      update: 'Actualizar',
      custom: 'Personalizado',
      base: 'Estándar',
    },
    requirements: {
      cols: {
        col1: 'Tipo',
        col2: 'Config.',
        col3: 'Selec. Múltiple'
      }
    },
    list: {
      enable_unit_cameras_do: {
        name: "Activar la salida digital de las cámaras",
        desc: "Activa la salida digital de las cámaras de la instalación",
      },
      enable_speaker: {
        name: "Activar DO1 del router",
        desc: "Activa el salida digital del router"
      },
      show_user_view: {
        name: "Mostrar vista/tab",
        desc: "Muestra una vista/tab en SBO"
      },
      delay: {
        name: "Retraso",
        desc: "",
        hint: "Cantidad de tiempo en segundos:"
      },
      active_digital_output_camera: {
        name: "Activar salida digital de las cámaras (old)",
        desc: "Activa salida digital de las cámaras",
        hint: "",
      },
      activate_digital_output_camera: {
        name: "Activar salida digital de las cámaras",
        desc: "Activa salida digital de las cámaras",
        hint: "",
      },
      deactivate_digital_output_camera: {
        name: "Desactivar salida digital de las cámaras",
        desc: "Desactiva salida digital de las cámaras",
        hint: "",
      },
      deactive_sound_router: {
        name: "Desactivar DO1 del router",
        desc: "Desactivar la salida digital del router",
        hint: "",
      },
      interphone_call: {
        name: "Llamada de interfon",
        desc: "Hace una llamda de interfon"
      },
      active_digital_output_rtu_router: {
        name: "Activar salida digital RTU router",
        desc: "Activa una salida digital especifica del router",
        hint: "",
      },
      density_shoot: {
        name: "Efectuar disparo real de neblina",
        desc: "Efectua un disparo real de neblina desde el dispositvo especificado",
      },
      density_test_shoot: {
        name: "Efectuar disparo de prueba de neblina",
        desc: "Efectua un disparo de prueba de neblina desde el dispositvo especificado",
      },
      notification_command: {
        name: "Envia una notificación",
        desc: "Envia una notificación desde diferentes maneras como Mensaje de Texto, Webhook, Correo Electronico, Whatsapp...",
      },
      show_action_plan: {
        name: "Mostrar un plan de acción",
        desc: "Muestra el plan de acción específicado",
      },
      send_c5_edomex: {
        name: "Envía alarma a C5 EDOMEX",
        desc: "Envía información de una alarma a C5 EDOMEX",
      },
      camera_round: {
        name: "Ronda de cámaras",
        desc: "Comando para iniciar una ronda de cámaras",
      },
      assignment_cameras: {
        name: "Asignación de camaras",
        desc: "Asignación de camaras",
      },
      alarm_panel_activate_output: {
        name: "Panel de alarma - Activar salida",
        desc: "Panel de alarma - Activar salida",
      },
      alarm_panel_deactivate_output: {
        name: "Panel de alarma - Desactivar salida",
        desc: "Panel de alarma - Desactivar salida",
      },
      activate_device_output: {
        name: "Activar salida de dispositivo",
        desc: "Activar salida de dispositivo",
      },
      deactivate_device_output: {
        name: "Desactivar salida de dispositivo",
        desc: "Desactivar salida de dispositivo",
      },
      activate_camera_ptz_preset: {
        name: "Activar el preajuste PTZ de una cámara",
        desc: "Activar el preajuste PTZ de una cámara",
      },
      activate_generic_device_digital_output: {
        name: "Activar salida digital de dispositivo genérico",
        desc: "Activar salida digital de dispositivo genérico",
      },
      deactivate_generic_device_digital_output: {
        name: "Desactivar la salida digital del dispositivo genérico",
        desc: "Desactivar la salida digital del dispositivo genérico",
      },
      assign_action_plan: {
        name: "Asignar tarea a usuarios",
        desc: "Asignar tarea a usuarios",
      },
      assign_operational_form_task: {
        name: "Asignar tarea de formulario de seguridad operativa",
        desc: "Asignar una tarea de formulario de seguridad operativa",
      },
      notify_panel_failure: {
        name: "Falla del panel",
        desc: "Notifica la falla del dispositivo a los usuarios con el permiso de notificaciones de falla de alarma",
      },
      response_operational_form: {
        name: "Crear respuesta de formulario de seguridad operativa",
        desc: "Crea una respuesta de formulario de seguridad operativa a partir de una plantilla",
      },
      "response-operational-form": {
        name: "Crear respuesta de formulario de seguridad operativa",
        desc: "Crea una respuesta de formulario de seguridad operativa a partir de una plantilla",
      },
      dispatch_alarm: {
        name: "Disparar alarma",
        desc: "Disparar alarma",
      },
      create_helpdesk_ticket: {
        name: "Crear ticket de helpdesk",
        desc: "Crear ticket de helpdesk",
      },
      alarm_image_inference: {
        name: "Inferir contexto de una imagen",
        desc: "Inferir contexto de una imagen",
      },
      update_alarm_level_command: {
        name: "Actualizar nivel de alarma",
        desc: "Actualiza el nivel de una alarma",
      },
      update_alarm_status_command: {
        name: "Actualizar estado de una alarma",
        desc: "Actualiza el estado de una alarma",
      },
      update_alarm_type_command: {
        name: "Actualizar tipo de una alarma",
        desc: "Actualiza el tipo de una alarma",
      },
      update_alarm_category_command: {
        name: "Categoría de alarma",
        desc: "Actualiza el protocolo de una alarma con un mensaje del catálogo",
      },
      ai_decision: {
        name: "AI Decision",
        desc: "AI Decision",
        decision: "Respuesta",
      },
      deactive_digital_output_rtu_router: {
        name: "Desctivar salida digital RTU router",
        desc: "Desactiva una salida digital especifica del router",
        hint: "",
      },
      action_execute_dmp_panel: {
        name: "Ejecutar acción en panel DMP",
        desc: "Ejecutar acción en panel DMP",
      },
      action_execute_intelbras_panel: {
        name: "Ejecutar acción en panel INTELBRAS",
        desc: "Ejecutar acción en panel INTELBRAS",
      },
      action_execute_pacom_panel: {
        name: "Ejecutar acción en panel PACOM",
        desc: "Ejecutar acción en panel PACOM",
      },
      assign_alarm_user: {
        name: "Asignar alarma a usuario",
        desc: "Asignar alarma a usuario",
      },
      activate_digital_output_hikvision_camera: {
        name: "Activar salida digital de una cámara Hikvision",
        desc: "Activar salida digital de una cámara Hikvision",
      },
      action_execute_panel_from_alarm: {
        name: "Ejecutar acción en panel desde alarma",
        desc: "Ejecutar acción en panel desde alarma",
      },
      send_external_cad_emergency_test: {
        name: 'Enviar prueba de emergencia CAD externa'
      },
      batch_alarm_attention: {
        name: 'Atención de alarmas por lote',
        desc: 'Atención de alarmas por lote'
      },
    },
    form: {
      units_select: {
        label: 'Selecciona la instalación para este nodo:'
      },
      cameras_select: {
        label: 'Selecciona las cámaras para este nodo:'
      },
      user_views_select: {
        label: 'Selecciona las vistas/tabs para este nodo:'
      },
      users_select: {
        label: 'Selecciona los usuarios para este nodo:'
      },
      profiles_select: {
        label: 'Selecciona los perfiles destino:',
        hint: 'Los perfiles destino deben de tener el permiso de "Recibir notificaciones del comando Notificación".',
      },
      interphone_from: {
        label: 'Seleccione el teléfono de origen:'
      },
      interphone_to: {
        label: 'Seleccione el teléfono de destino:'
      },
      density_device: {
        label: 'Seleccione el dispositivo Density:'
      },
      type_notificaction: {
        label: 'Tipo de notificación:'
      },
      type_verb_webhook: {
        label: 'Verbo RESTful:'
      },
      url1: {
        label: 'Introduce la URL de la alarma',
      },
      url2: {
        label: 'Introduce la URL de retroalimentaciones de la alarma',
      },
      action_plan: {
        label: 'Seleccione un plan de acción:'
      },
      operational_form_template_select: {
        label: 'Seleccione la plantilla de formulario de seguridad operativa:'
      },
      alarm_select: {
        label: 'Enlazar una alarma (opcional):'
      },
      comment: {
        label: 'Comentario (opcional)'
      },
      comment_field: {
        label: 'Comentario (opcional)'
      },
      layouts: {
        label: 'Seleccione un diseño:'
      },
      location: {
        label: 'Ingrese la ubicación:',
        fields: {
          lat: 'Latitud',
          lng: 'Longitud',
          from_alarm: 'Tomar valor de la alarma'
        }
      },
      radius: {
        label: 'Ingrese el radio:'
      },
      delay: {
        label: 'Ingrese el retraso',
      },
      loop: {
        label: 'Bucle:'
      },
      message_template: {
        label: 'Plantilla del mensaje',
        characters_remaining: 'Caracteres restantes',
        available_placeholders: 'Placeholders disponibles',
        insert_placeholder: 'Insertar placeholder',
        placeholder_hint: 'Escribe @ para buscar e insertar un placeholder.',
        search_placeholder: 'Buscar placeholder…',
        no_placeholders_found: 'No se encontraron placeholders.',
        categories: {
          alarm: 'Alarmas',
          location: 'Ubicación',
          camera: 'Cámara',
          media: 'Multimedia',
          other: 'Otros',
        },
        placeholders: {
          alarm_image: 'URL de la imagen cuando la alarma proviene de un evento de analítica de video',
          alarm_image_url: 'URL de la imagen cuando la alarma proviene de un evento de analítica de video',
          municipality: 'Municipio de la instalación',
          region: 'Región de la instalación',
          facility_format: 'Texto anterior al primer "_" de la descripción de la instalación (MBA en MBA_3030)',
          facility_determinant: 'Texto posterior al primer "_" de la descripción de la instalación (3030 en MBA_3030)',
          camera_name: 'Nombre de la cámara asociada a la alarma',
          facility_comment: 'Comentarios de la instalación',
        },
        help: {
          header: 'Escribe el texto que se enviará por WhatsApp. Puedes utilizar lo siguientes placeholders que posteriormente serán reemplazados con la información de la alarma:',
          footer: {
            title: 'Ejemplo:',
            body: 'Comando ejecutado desde el instalación @facility_name, id de alarma #@id_alarm del tipo @alarm_type'
          }
        }
      },
      subject: {
        label: 'Asunto',
      },
      groups_select: {
        label: 'Selecciona los grupos para este nodo:'
      },
      tenants_select: {
        label: 'Selecciona los tenants para este nodo:'
      },
      centers_select: {
        label: 'Selecciona los centros para este nodo:'
      },
      sectors_select: {
        label: 'Selecciona los sectores para este nodo:'
      },
      filter_field: {
        label: 'Agregar filtro para este nodo:'
      },
      email: {
        label: 'Introduce los correos electrónicos',
      },
      phone: {
        label: 'Introduce los teléfonos',
      },
      receiver: {
        label: 'Introduce el receptor',
      },
      authorization: {
        label: 'Introduce tu clave de autorización',
      },
      json_editor: {
        apply: 'Aplicar',
        cancel: 'Cancelar',
        expand: 'Abrir editor JSON',
        format: 'Dar formato',
        invalid: 'JSON no válido',
        title: 'Editor de plantilla JSON',
        valid: 'JSON válido',
      },
      alarm_panels: {
        label: 'Seleccione el panel de alarma'
      },
      alarm_panel_devices: {
        label: 'Selecciona un dispositivo del panel',
        hint: 'Nota: Cuando se toma el valor desde una alarma, "Input" y "Zone" son lo mismo.'
      },
      cmd_config: {
        label: 'Configuración de comando',
        hint: 'Selecciona el comando y luego defina su configuración a continuación.'
      },
      camera_ptz_presets: {
        label: 'Presets PTZ de cámara',
        hint: 'Escriba o seleccione un ajuste preajuste PTZ para la cámara'
      },
      device_tags: {
        label: 'Etiquetas de dispositivo',
        hint: 'Escriba o seleccione una etiqueta de dispositivo'
      },
      device_proxy_id: {
        label: 'Dispositivo',
        hint: 'Seleccione un dispositivo'
      },
      alarm_types: {
        label: 'Seleccione un tipo de alarma',
        hint: 'Seleccione un tipo de alarma'
      },
      helpdesk_users_from: {
        label: 'Seleccione un usuario',
        hint: 'Seleccione el usuario que creará el ticket'
      },
      helpdesk_users_to: {
        label: 'Seleccione los usuarios',
        hint: 'Seleccione los usuarios que deben recibir copia del e-mail'
      },
      helpdesk_groups: {
        label: 'Grupos',
        hint: 'Seleccione los grupos asociados al ticket'
      },
      prompt: {
        label: 'Ingrese un prompt',
      },
      alarm_levels: {
        label: 'Seleccione un nivel de alarma',
      },
      alarm_status: {
        label: 'Seleccione un status de alarma',
      },
      message: {
        label: 'Ingrese el mensaje',
      },
      group_name: {
        label: 'Nombre del grupo',
        hint: 'Introduce el nombre del grupo.'
      },
      cat_base_url: {
        label: 'Url'
      },
      cat_user_id: {
        label: 'Id de usuario'
      },
      cat_timeout: {
        label: 'Tiempo de espera'
      },
      sectors: {
        label: 'Seleccione un sector',
        hint: 'Selecciona un sector.'
      },
    },
    data_types: {
      users: 'Usuarios',
      profiles: 'Perfiles',
      user_views: 'Vistas de usuario',
      units: 'Instalaciones',
      cameras: 'Cámaras',
      phone: 'Teléfonos',
      email: 'E-mails',
      log_id: 'Registros',
      do: 'Salida digital',
      interphone_from: 'Llamada interfon (de)',
      interphone_to: 'Llamada interfon (a)',
      message_template: 'Mensaje',
      subject: 'Asunto',
      type: 'Tipo de notificación',
      receiver: 'Receptor',
      verb: 'Verbo RESTful',
      authorization: 'Authorización',
      url1: 'URL de alarma',
      url2: 'URL de comentarios para alarma',
      webhook: 'URL Webhook',
      action_plan: 'Plan de acción',
      operational_form_template: 'Plantilla de formulario de seguridad operativa',
      alarm: 'Alarma',
      alarm_category_message: 'Mensaje de categoría de alarma',
      comment: 'Comentario',
      delay: 'Retraso',
      layout: 'Layouts',
      location: 'Ubicación',
      radius: 'Radio',
      loop: 'Bucle',
      density_device: 'Dispositivo Density',
      groups: 'Grupos',
      tenants: 'Tenants',
      centers: 'Centros',
      sectors: 'Sectores',
      filter: 'Filtros',
      alarm_panels: 'Paneles de alarma',
      alarm_panel_devices: 'Dispositivos del panel de alarmas',
      cmd_config: 'Configuración de comando',
      camera_ptz_presets: 'Presets PTZ de cámara',
      device_tags: 'Etiquetas de dispositivo',
      device_proxy_id: 'Dispositivo',
      alarm_types: 'Tipos de alarma',
      helpdesk_groups: 'Grupos de helpdesk',
      helpdesk_users_from: 'Usario',
      helpdesk_users_to: 'Usuarios',
      commands:{
        form: {
          cameras_select: {
            label: 'Seleccionar cámaras'
          }
        }
      }
    },
    flowchart: {
      show_hide_node_config: 'Mostrar/ocultar configuración del comando',
    },
    gridWidget: {
      title: 'Comandos',
      table: {
        no_data: "No hay información disponible",
        rows: {
          1: "Nombre",
          2: "Descripción",
        }
      }
    },
    cameras: {
      label: 'Cámaras'
    },
    modal: {
      title: 'Ejecución de comando',
      body: 'Se ejecutará el siguiente comando',
      btns: {
        continue: 'Continuar',
        cancel: 'Cancelar'
      },
      messages: {
        success: 'Estado: Comando puesto en ejecución correctamente',
        error: 'Estado: Ocurrió un error'
      }
    },
    config_modal: {
      title: 'Configuración del comando',
      messages: {
        invalid_form: 'Por favor, corrige los errores en el formulario',
      },
      chart: {
        label: 'Gráfico incrustado',
        hint: 'Muestra un gráfico dentro del nodo (datos de demostración).',
        types: {
          none: 'Ninguno',
          bar: 'Barras',
          line: 'Líneas',
          pie: 'Circular',
          graph: 'Grafo (fuerza)',
        }
      }
    },
    logs: {
      title: 'Log de comandos',
      filters: {
        commands: 'Comandos'
      },
      table: {
        id_operation: 'ID de operación',
        user: 'Usuario',
        description: 'Descripción',
        command: 'Comando',
        command_source: 'Comando relacionado',
        level: 'Nivel',
        data: 'Info.',
        date: 'Fecha'
      }
    },
    units: {
      seconds: 'segundo(s)',
      meters: 'metro(s)',
    },
    panels: {
      user_panel: 'Panel',
      device_panel: 'Dispositivo',
      action_panel: 'Acción'
    },
    device_action_panel: {
      title: 'Acción de dispositivo',
      action: 'Acción',
      actions: {
        RESTORE: 'Restaurar',
        RESET: 'Restablecer',
        BYPASS: 'Bypass',
        ARM: 'Armar',
        DISARM: 'Desarmar',
      },
    },
    selectable: {
      modal_title: 'Configurar campo',
      type_field: 'Tipo de campo',
      name: 'Nombre',
      option: 'Opcion',
      options: 'Opciones',
      addOptions: 'Agregar opción',
      no_options: 'Sin opciones registradas',
      optionsRequired: 'El campo opciones es requerido',
      selectField: 'Seleccionar tipo de campo'
    }
  }
}
